
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M12 1C5.928 1 1 5.928 1 12s4.928 11 11 11 11-4.928 11-11S18.072 1 12 1z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M12.056 15.03a1.1 1.1 0 110 2.2 1.1 1.1 0 010-2.2zm-.054-8.002l.192.006c.732.051 1.296.29 1.786.883.577.698.758 1.623.427 2.482-.166.43-.383.717-.725 1.04-.462.437-.439.413-.58.63-.151.23-.17.317-.165.542.001.067.002.114 0 .167a.99.99 0 11-1.979-.056v-.065c-.015-.593.089-1.066.488-1.674.263-.402.28-.419.876-.983.146-.138.193-.2.237-.313.065-.168.03-.345-.105-.509-.106-.128-.165-.153-.398-.17-.28-.019-.667.165-.85.404a.99.99 0 11-1.572-1.204c.58-.756 1.602-1.241 2.56-1.174z","fill":"#FFF"}})])])
          )
        }
      }
    